import {
  tracker
} from '../constants';

/**
 * Import constants
 */
const {
  TOOK_RF_QUIZ,
  TOOK_MM_QUIZ,
  TOOK_LM_QUIZ,
  SET_WHOLE_TRACKER
} = tracker;

/**
 * Action creators
 */
const actions = {
  setTimesTookRfQuiz: (data) => ({ type: TOOK_RF_QUIZ, data }),
  setTimesTookMmQuiz: (data) => ({ type: TOOK_MM_QUIZ, data }),
  setTimesTookLmQuiz: (data) => ({ type: TOOK_LM_QUIZ, data }),
  setWhole: (data) => ({ type: SET_WHOLE_TRACKER, data })
};

/**
 * Track number of times user took the RF quiz
 */
export const setTimesTookRfQuiz = (data) => (dispatch) => dispatch(
  actions.setTimesTookRfQuiz(data)
);

/**
 * Track number of times user took the MM quiz
 */
export const setTimesTookMmQuiz = (data) => (dispatch) => dispatch(
  actions.setTimesTookMmQuiz(data)
);

/**
 * Track number of times user took the LM quiz
 */
export const setTimesTookLmQuiz = (data) => (dispatch) => dispatch(
  actions.setTimesTookLmQuiz(data)
);

/**
 * Set whole tracker data
 */
export const setWhole = (data) => (dispatch) => dispatch(
  actions.setWhole(data)
);
